import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { GetOrdersVm } from './get-orders.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { OrdersStatus } from './order.vm';

export const getOrders = async (
  offset: string,
  term: string,
  supplier: string,
  status: OrdersStatus | null,
  callback: CallbackObject<GetOrdersVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  if (supplier) {
    config.params.supplierId = supplier;
  }

  if (status) {
    config.params.status = status;
  }

  try {
    const res: AxiosResponse = await instance.get(`/reception/orders`, config);
    callback.success(plainToClass(GetOrdersVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
